import {
  Component,
  Input,
  forwardRef,
  ElementRef,
  ChangeDetectorRef,
  HostListener,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-single-select-dropdown',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './single-select-dropdown.component.html',
  styleUrls: ['./single-select-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SingleSelectDropdownComponent),
      multi: true
    }
  ]
})
export class SingleSelectDropdownComponent implements ControlValueAccessor, OnChanges {
  @Input() list: any[] = [];
  @Input() placeholder: string = 'Select';
  @Input() displayKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();


  searchTerm: string = '';
  showDropDown = false;
  selectedItem: any = null;
  disabled = false;
  private _value: any;

  onChange = (_: any) => {};
  onTouched = () => {};

  constructor(private elementRef: ElementRef, private cdr: ChangeDetectorRef) {}

  writeValue(value: any): void {
    this._value = value;
    if (!this.list || this.list.length === 0) {

      return;
    }

    this.selectedItem = this.list.find(item => String(item[this.valueKey]) === String(value)) || null;

    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['list'] && this._value !== undefined && this._value !== null) {
      this.writeValue(this._value);
    }
  }


  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.detectChanges();
  }

  toggleDropDown() {
    if (this.disabled) return;
    this.showDropDown = !this.showDropDown;

    if (!this.showDropDown) {
      this.onTouched();
      this.searchTerm = '';
    }
    this.cdr.detectChanges();
  }

  selectItem(item: any) {
    this.selectedItem = item;
    this.onChange(item[this.valueKey]);
     this.selectionChange.emit(item);
    this.showDropDown = false;
    this.searchTerm = '';
    this.cdr.detectChanges();
  }

 get filteredList(): any[] {
  if (!this.searchTerm) return this.list;

  const term = this.searchTerm
    .toLowerCase()
    .replace(/\s+/g, ''); // space hatao

  return this.list.filter(item => {
    const value = String(item[this.displayKey] || '')
      .toLowerCase()
      .replace(/\s+/g, '');

    return value.includes(term);
  });
}



  @HostListener('window:click', ['$event'])
  handleOutsideClick(event: Event) {
    if (this.showDropDown && !this.elementRef.nativeElement.contains(event.target)) {
      this.showDropDown = false;
      this.searchTerm = '';
      this.cdr.detectChanges();
    }
  }
}

